import { CommitmentTypes } from 'legacy/lut/components/widgets/public/partner360/commitment/models'
import type { ICommitmentData } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentData'

import { CockpitUserType, type IFinancialCockpitUserWithScope } from '../api/types'

const toPlanKey = (partnerId: string, offering: string) => `${partnerId}|${offering}`

/**
 * `Users` plus the PBM signer of every plan `Users` names no PBM for. The payload sends
 * `Users` only for plans with pending actions, so a plan without them would otherwise have no
 * PBM at all; its acknowledgment always names one.
 */
export const withCommitmentPbmUsers = (
  users: IFinancialCockpitUserWithScope[],
  commitmentData: ICommitmentData[]
): IFinancialCockpitUserWithScope[] => {
  const plansWithPbm = new Set(
    users
      .filter(({ UserType }) => UserType === CockpitUserType.PBM)
      .map(({ PartnerId, Offering }) => toPlanKey(PartnerId, Offering))
  )
  const signers = new Map<string, IFinancialCockpitUserWithScope>()

  commitmentData.forEach(
    ({ CommitmentType, Dropped, SignerEmail, SignerName, PartnerId, ProgramType, EntryId }) => {
      const planKey = toPlanKey(PartnerId, ProgramType)
      const signerKey = `${planKey}|${SignerEmail?.toLowerCase()}`

      if (
        CommitmentType !== CommitmentTypes.PBM ||
        Dropped ||
        !SignerEmail ||
        plansWithPbm.has(planKey) ||
        signers.has(signerKey)
      ) {
        return
      }

      signers.set(signerKey, {
        UserType: CockpitUserType.PBM,
        Id: EntryId,
        Email: SignerEmail,
        FullName: SignerName ?? '',
        PartnerId,
        Offering: ProgramType,
      })
    }
  )

  return [...users, ...signers.values()]
}
